<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Privacy', to: { path: '/privacy' } },
        { name: 'Edit', to: { path: '/privacy/edit' } },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯 Privacy</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <!-- Page Tilte -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5"><h4>Page Tilte</h4></div>
        <div class=" my-n2 flex-grow-1">
          <div class="form-input-group"><input type="text" /></div>
          <div class="mt-1 h5 ink-02-medium--text text-right">0/50</div>
        </div>
      </label>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Image</h4>
          <div class="h5 ink-02-medium--text">
            呈現於BU Page及Overview Page <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader></ImgUploader>
        </div>
      </div>
    </div>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Content</h3>
        <div class="h4">
          至少需填寫一組內容 <br />
          可添加欄位做內容擴充
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5" v-for="(item, i) in itemList" :key="item.id">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Content</h4>
            <button
              v-if="i > 0"
              class="btn btn-danger square w-32px h-32px"
              @click="deleteItem(item)"
            >
              <v-icon color="white">delete</v-icon>
            </button>
          </div>
          <!-- Section Tabs -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Section Tabs</h4>
            <div class="form-input-group my-n2 flex-grow-1">
              <input type="text" v-model="item.sectionTabs" />
            </div>
          </label>
          <!-- Title -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="form-input-group my-n2 flex-grow-1">
              <input type="text" v-model="item.title" />
            </div>
          </label>
          <!-- Description -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div class="my-n2 flex-grow-1">
              <textarea
                style="height: 132px"
                v-model="item.description"
              ></textarea>
            </div>
          </label>
        </div>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content</span>
          </button>
        </div>
        <div class="page-actions">
          <v-spacer></v-spacer>
          <button class="btn mr-5" @click="cancelHandler">
            <span>取消</span>
          </button>
          <button class="btn btn-primary" @click="saveHandler">
            <span>儲存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    Breadscrumbs,
    ImgUploader,
  },
  data: () => ({
    itemList: [
      {
        id: '001',
        sectionTabs: 'Tab Label',
        title: 'title 01',
        description: 'content 01',
      },
      {
        id: '002',
        sectionTabs: 'Tab Label',
        title: 'title 02',
        description: 'content 02',
      },
    ],
  }),
  methods: {
    addItem() {
      const template = {
        id: Date.now(),
        title: `title ${Date.now()}`,
        description: '',
        visualUrl: '',
      };
      this.itemList.push(template);
    },
    deleteItem(item) {
      const index = this.itemList.map((i) => i.id).indexOf(item.id);
      this.itemList.splice(index, 1);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
